export default "__VITE_ASSET__DtGfr9BH__"